import React, { useEffect, useState } from 'react'
import { classes, ViewerInfoStyle } from './style'
import Button from '@mui/material/Button'
import clsx from 'clsx'
import { Fab, Tooltip, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import Container from '@mui/material/Container'
import TextField from '@mui/material/TextField'
import { Link as Scroll } from 'react-scroll'

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import Icon from '@mui/material/Icon'
import MessageIcon from '@mui/icons-material/Message'

import { useDispatch, useSelector } from 'react-redux'

import mapImg from '../../../assets/map.png'
import Footer from '../../../components/footer'
import { getUnitWithDetails } from '../../../actions/viewerActions'
import { useParams } from 'react-router-dom'
import Loading from '../../../components/loading'
import Divider from '@mui/material/Divider'
import { AccountCircle, Email } from '@mui/icons-material'
import Box from '@mui/material/Box'

const headerDetails = [
  { key: 'price', label: 'Price', icon: 'selly', value: '' },
  { key: 'surface', label: 'Surface', icon: 'border_style', value: '' },
  { key: 'type', label: 'Type', value: '', icon: 'apartment' },
  { key: 'bathroom', label: 'Bathroom', value: '', icon: 'shower' },
  { key: 'rooms', label: 'Rooms', value: '', icon: 'bed' },
  { key: 'toilette', label: 'Roilette', value: '', icon: 'wc' },
  { key: 'stateRank', label: 'Rank', value: '', icon: 'trending_up' }

]
const propertiesSpecifics = [
  { label: 'Building Name', value: 'N/A' },
  { label: 'Pet Policy', value: 'N/A' },
  { label: 'Property Type', value: 'Co-op' },
  { label: 'Building Type', value: 'N/A' },
  { label: 'Units', value: 'N/A' },
  { label: 'Stories', value: 'N/A' },
  { label: 'Sale Listings', value: '1' },
  { label: 'Rental Listings', value: '0' },
  { label: 'Land Lease', value: 'N/A' },
  { label: 'Built in', value: 'N/A' }

]

// eslint-disable-next-line react/prop-types
const Information = ({ callbackClick }) => {
  const dispatch = useDispatch()
  const { unitId } = useParams()
  const [details, setDetails] = useState(headerDetails)
  const unitDetailsStore = useSelector(state => state.viewer.unitDetails)
  const loading = useSelector(state => state.viewer.loading)

  const [offset, setOffset] = useState(0)
  const updateDetails = () => {
    const addValuesDetails = details.map((item) => {
      const name = item.key
      item.value = unitDetailsStore[name]
      return item
    })

    setDetails(addValuesDetails)
  }
  useEffect(() => {
    updateDetails()
  }, [unitDetailsStore])

  useEffect(() => {
    dispatch(getUnitWithDetails(unitId))
  }, [])
  useEffect(() => {
    if (!offset) {
      const button2 = document.getElementById('button2')
      if (button2) {
        button2.click()
      }
    }
  }, [offset])

  useEffect(() => {
    const onScroll = () => setOffset(window.pageYOffset)
    window.removeEventListener('scroll', onScroll)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
        <>
            <ViewerInfoStyle
                id="info"
                className={clsx({
                  [classes.root]: true
                  // [classes.top]: top
                })}
            >
                <Loading open={loading} position="fixed" type="circular"/>
                <div id="button2" className={classes.btnTop}>
                    <Fab color="primary" onClick={() => callbackClick()}>
                        <ArrowUpwardIcon/>
                    </Fab>
                </div>

                <Container>
                    <Grid container spacing={4}>
                        <Grid item >
                            <Typography variant="h4">
                              Unit Information
                            </Typography>
                            <br/>
                            <br/>
                            <Scroll to="form">
                                <Button variant="contained" color="primary">Contact Us</Button>
                            </Scroll>
                          <Divider className={classes.divider}/>
                          <div className={classes.contentDeails}>
                            {details.map((item) => (
                                  <Typography key={item.key} textAlign="center" variant="body2" fontWeight="bold" style={{ textTransform: 'capitalize' }}>
                                    <Tooltip title={item.label} placement="top">
                                      <Icon color="primary" fontSize="medium" className={classes.icon}>{item.icon}</Icon>
                                    </Tooltip>
                                    <br/>
                                    <span style={{ textTransform: 'lowercase', color: 'gray' }}>
                                      {item.value} {item.key === 'surface' && <>m <sup>2</sup></> }
                                    </span>

                                  </Typography>
                            ))}
                          </div>
                          <Divider className={classes.divider}/>
                            <Typography align="left" fontWeight="bold" variant="body1">Property Description</Typography>
                            <br/>
                            <Typography variant="body1" align="left" className={classes.listDescription}>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                                sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                Ut enim ad minim veniam, quis nostrud exercitation ullamco
                                laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
                                dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum
                            </Typography>
                          <Divider className={classes.divider}/>
                        </Grid>
                        <Grid item md={12}>
                            <Typography align="left" fontWeight="bold" variant="body1">Property Taxes</Typography>
                            <br/>
                            <Grid container>
                                {
                                    propertiesSpecifics.map((item, i) => {
                                      return (
                                            <Grid item md={4} key={i}>
                                                <Typography component="p" align="left" variant="caption">
                                                  <span className={classes.bullet}/>
                                                  {item.label} <b>{item.value}</b>
                                                </Typography>
                                            </Grid>
                                      )
                                    })
                                }
                            </Grid>
                        </Grid>
                        <Grid item md={12} xs={12}>
                            <Typography align="left" fontWeight="bold" variant="body1">Building Information</Typography>
                            <br/>
                            <Grid container>
                                {
                                    propertiesSpecifics.map((item, i) => {
                                      return (
                                            <Grid item md={4} key={i}>
                                                <Typography component="p" align="left" variant="caption">
                                                  <span className={classes.bullet}/>
                                                  {item.label} <b>{item.value}</b>
                                                </Typography>
                                            </Grid>
                                      )
                                    })
                                }
                            </Grid>
                        </Grid>
                        <Grid item md={12} xs={12}>
                          <Divider className={classes.divider}/>
                            <Typography align="left" fontWeight="bold" variant="body1">Ubication</Typography>
                            <Typography align="left" variant="body1">
                              {unitDetailsStore.buildingAddress}, {unitDetailsStore.stateName}
                            </Typography>
                            <img className={classes.imgMap} src={mapImg} />

                        </Grid>
                        <Grid item md={12}>
                          <Divider className={classes.divider}/>
                            <Typography align="left" fontWeight="bold" variant="body1">Contact us</Typography>
                            <br/>
                            <div id="form">
                                <Grid container spacing={4}>
                                    <Grid item md={12} sm={12} xs={12}>
                                      <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                        <AccountCircle color="primary" />
                                        <TextField className={classes.field} id="input-with-sx" label="Name" variant="standard" />
                                      </Box>
                                    </Grid>
                                    <Grid item md={12} sm={12} xs={12}>
                                      <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                        <Email color="primary" />
                                        <TextField className={classes.field} id="input-with-sx2" label="Email" variant="standard" />
                                      </Box>
                                    </Grid>
                                    <Grid item md={12} sm={12} xs={12}>

                                      <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                        <MessageIcon color="primary" />
                                        <TextField
                                          className={classes.field}
                                          id="outlined-multiline-static"
                                          label="Message"
                                          multiline
                                          variant="standard"
                                        />
                                      </Box>

                                    </Grid>
                                    <Grid item md={12} sm={12} xs={12}>
                                        <Button variant="contained" color="primary">Send</Button>
                                    </Grid>
                                </Grid>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </ViewerInfoStyle>
            <Footer/>
        </>
  )
}

export default Information
